import { rest } from '@0xtorch/core'
import { z } from 'zod'
import { bybitApiEndpoint } from './constants'
import { commonResponseSchema, successReponseSchema } from './schemas'
import { createPrivatePostHeaders } from './utils'

const responseSchema = successReponseSchema.extend({
  result: z.object({
    registerTime: z
      .string()
      .regex(/^\d+$/)
      .transform((v) => Number.parseInt(v, 10) * 1000),
  }),
})

type GetBybitUserRegisterDataParameters = {
  apiKey: string
  apiSecret: string
  proxy?: string
  headers?: Record<string, string>
}

const urlPath = '/fht/compliance/tax/v3/private/registertime'

export const getBybitUserRegisterData = async ({
  apiKey,
  apiSecret,
  proxy,
  headers,
}: GetBybitUserRegisterDataParameters): Promise<number> => {
  const url = new URL(urlPath, bybitApiEndpoint)
  const response = await rest(
    proxy === undefined
      ? url.toString()
      : `${proxy}${encodeURIComponent(url.toString())}`,
    {
      fetchOptions: {
        method: 'POST',
        headers: {
          ...headers,
          ...(await createPrivatePostHeaders({
            apiKey,
            apiSecret,
            body: '',
          })),
        },
      },
      schema: z.union([responseSchema, commonResponseSchema]),
    },
  )
  if (!('result' in response)) {
    throw new Error(response.retMsg)
  }
  return response.result.registerTime
}
